module.exports = __webpack_public_path__ + "static/img/34.38d6da3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/34.png
// module id = LR/j
// module chunks = 0